import { render, staticRenderFns } from "./NewPets.vue?vue&type=template&id=4cb126ae&scoped=true"
import script from "./NewPets.vue?vue&type=script&lang=js"
export * from "./NewPets.vue?vue&type=script&lang=js"
import style0 from "./NewPets.vue?vue&type=style&index=0&id=4cb126ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb126ae",
  null
  
)

export default component.exports